(function () {
    // EVENT LISTENERS
    // open choose variant modal  
    document.querySelectorAll(".choose-variant").forEach(button => {
        button.addEventListener("click", openModalSet);
    });

    // add event listener to atc button
    document.querySelector("button.gwp-modal__atc").addEventListener("click", addToCart);

    // event listener toggle modal
    document.querySelectorAll(".gwp-modal__header>img, .gwp-dark").forEach(el => el.addEventListener("click", closeModalSet));

    // FUNCTION SETS
    function openModalSet(event) {
        toggleModal();
        insertVariantToModal(getProductData(event));
    }

    function closeModalSet() {
        toggleModal();
        clearModalList();
        resetAtcButton();
    }

    function selectVariantSet(event) {
        console.log("target", event, event.target, this);
        addSelectedVariant(this);
        toggleVariantData(this);
    }

    // FUNCTIONS
    function addToCart() {
        let body = {
            items: [
                {
                    id: parseInt(this.dataset.selected),
                    quantity: parseInt("1"),
                }
            ]
        };

        fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
        })
            .then((response) => {
                response.json();
            })
            .then(() => {
                window.location = "/cart";
            })
            .catch((error) => {
                console.error("Error:", error);
            });

    }

    function resetAtcButton() {
        const button = document.querySelector(".gwp-modal__atc");
        button.disabled = true;
        button.dataset.selected = "";
    }

    function addSelectedVariant(element) {
        const button = document.querySelector("button.gwp-modal__atc");
        button.disabled = false;
        button.dataset.selected = element.dataset.variantId;
    }

    function toggleVariantData(element) {
        const parent = element.parentNode;
        const children = Array.from(parent?.childNodes).filter(child => child.dataset.state == "selected");
        children?.forEach(child => child.dataset.state = "");
        element.dataset.state = "selected";
    }

    function insertVariantToModal(productData) {
        const parent = document.querySelector(".gwp-modal .gwp-modal__list");

        productData?.variants?.forEach(variant => {
            // Create variant button
            let button = document.createElement("button");
            button.dataset.variantId = variant.id;
            button.disabled = !variant.available;

            // Create span
            let span = document.createElement("span");
            span.innerText = formatVariantTitle(variant.title);

            // Get variant color & create swatch
            if (getMetafieldColor(getMetafieldData(), variant.id)) {
                let div = document.createElement("div");
                div.classList.add("gwp-modal__color");
                div.style.background = getMetafieldColor(getMetafieldData(), variant.id).split("-").pop();

                // Append swatch
                button.append(div);
            }

            // Append span to button
            button.append(span);

            // Append new button to parent
            parent?.append(button);

            // Add event listener select variant
            button.addEventListener("click", selectVariantSet);
        });
    }

    function getProductData(event) {
        const productsObj = JSON.parse(document.getElementById('choose-variants').textContent);
        return productsObj.find(x => x.id == event.target.dataset.product);
    }

    function toggleModal() {
        const modal = document.querySelector(".gwp-modal");
        modal.dataset.state = modal.dataset.state == "open" ? "" : "open";
    }

    function clearModalList() {
        const list = document.querySelector(".gwp-modal__list");
        list.replaceChildren();
    }

    function getMetafieldData() {
        return JSON.parse(document.getElementById('choose-variants-color').textContent);
    }

    function getMetafieldColor(metafieldData, variantId) {
        return metafieldData.find(x => x.includes(variantId));
    }

    function formatVariantTitle(title) {
        return title.toLowerCase().replace("default title", "default variant");
    }

    // MUTATION OBSERVER
    const mutationObserver = new MutationObserver(async (mutations, observer) => {
        for (mutation of mutations) {
            const classNames = ['gwp-wrapper', 'gwp-modal', 'gwp-modal__list', 'gwp-bar', 'gwp-bar__text'];

            if (classNames.some(className => mutation.target.classList.contains(className))) break;

            fetch("https://www.buttonscarves.com/cart")
                .then((response) => response.text())
                .then((responseText) => {
                    // 1. Replace DOMs
                    const selectors = [".gwp-bar", ".gwp-bar__text"];
                    selectors.forEach(s => {
                        const _dom = new DOMParser()
                            .parseFromString(responseText, "text/html")
                            .querySelector(s).innerHTML;
                        document.querySelector(s).innerHTML = _dom;
                    });

                    // 2. Replace GWP Item
                    const _gwpItems = new DOMParser()
                            .parseFromString(responseText, "text/html")
                            .querySelectorAll(".gwp-gift__item");

                    
                    document.querySelectorAll(".gwp-gift__item").forEach(item => {
                        const _item = Array.from(_gwpItems).find(gwpItem => gwpItem.dataset.product == item.dataset.product);
                        
                        if (_item) {
                            // 2.1 Replace class list
                            item.classList = _item.classList;

                            // 2.2 Replace disabled attribute
                            item.querySelector("button").disabled = _item.querySelector("button").disabled;
                        }

                        
                    });
                });
        }
        observer.disconnect;
    });

    const moCartItems = document.querySelector("cart-items");
    mutationObserver.observe(moCartItems, {
        subtree: true,
        characterData: true,
        childList: true,
    });

}())


